

export const AUTH_ENDPOINTS = {

  // Status endpoint
  STATUS: { path: `/auth/status`, method: "GET" },

  // Authentication endpoints
  LOGIN: { path: `/auth/login`, method: "POST" },
  LOGIN_OTP: { path: `/auth/login/otp`, method: "POST" },
  LOGIN_OTP_REQUEST: { path: `/auth/login/otp/request`, method: "POST" },

  REGISTER: { path: `/auth/register`, method: "POST" },
  LOGOUT: { path: `/auth/logout`, method: "POST" },
  REFRESH_TOKEN: { path: `/auth/refresh`, method: "POST" },

  // Email verification
  VERIFY_EMAIL: { path: `/auth/verify-email`, method: "POST" },
  RESEND_VERIFICATION: { path: `/auth/resend-verification`, method: "POST" },

  // Password management
  UPDATE_PASSWORD: { path: `/auth/update-password`, method: "POST" },
  FORGOT_PASSWORD: { path: `/auth/forgot-password`, method: "POST" },
  RESET_PASSWORD: { path: `/auth/reset-password`, method: "POST" },
  CHANGE_PASSWORD: { path: `/auth/change-password`, method: "POST" },

  // OAuth endpoints
  GOOGLE_LOGIN: { path: `/auth/google/login`, method: "GET" },
  GOOGLE_CALLBACK: { path: `/auth/google/callback`, method: "GET" },

  // User management
  GET_USER: { path: `/auth/me`, method: "GET" },
  UPDATE_PROFILE: { path: `/auth/me`, method: "PUT" },
  DELETE_ACCOUNT: { path: `/auth/me`, method: "DELETE" },

  // Session management
  GET_SESSIONS: { path: `/auth/sessions`, method: "GET" },
  REVOKE_SESSION: { path: `/auth/sessions/:sessionId`, method: "DELETE" },
  REVOKE_ALL_SESSIONS: { path: `/auth/sessions`, method: "DELETE" },

  // Passkey (WebAuthn)
  PASSKEY_REGISTER_OPTIONS: {    path: `/auth/passkey/register/options`,    method: "POST"  },
  PASSKEY_REGISTER_VERIFY: {    path: `/auth/passkey/register/verify`,    method: "POST"  },
  PASSKEY_LOGIN_OPTIONS: {    path: `/auth/passkey/login/options`,    method: "POST"  },
  PASSKEY_LOGIN_VERIFY: {    path: `/auth/passkey/login/verify`,    method: "POST"  },
  PASSKEY_LIST: {    path: `/auth/passkey/list`,    method: "GET"  },
  PASSKEY_DELETE: {    path: `/auth/passkey/delete`,    method: "POST"  },

  // Biometrics
  GET_BIOMETRICS: { path: `/auth/biometrics`, method: "GET" },
  ENROLL_BIOMETRIC: { path: `/auth/biometrics`, method: "POST" },
  REVOKE_BIOMETRIC: { path: `/auth/biometrics/:biometricId`, method: "DELETE" },
  GENERATE_BIOMETRIC_CHALLENGE: { path: `/auth/biometrics/challenge`, method: "POST" },

  // Two-factor authentication
  ENABLE_2FA: { path: `/auth/2fa/enable`, method: "POST" },
  DISABLE_2FA: { path: `/auth/2fa/disable`, method: "POST" },
  VERIFY_2FA: { path: `/auth/2fa/verify`, method: "POST" },


  // SU Endpoints
  SU_UPDATE_USER: { path: `/auth/su/update-user`, method: "POST" },
};